import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',{staticClass:"fill-height"},[_c(VRow,[_c(VCol,{attrs:{"cols":"auto"}},[_c('SideNav')],1),_c(VCol,{attrs:{"cols":"12"}},[_c('router-view')],1)],1)],1):_c('div',{staticClass:"loading-container"},[_c('Loader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }